// extracted by mini-css-extract-plugin
export var checkmark = "OptionTile-module--checkmark--5fdb1";
export var container = "OptionTile-module--container--34d38";
export var image = "OptionTile-module--image--2e63a";
export var label = "OptionTile-module--label--3960b";
export var placeholder = "OptionTile-module--placeholder--52869";
export var selected = "OptionTile-module--selected--fd2ab";